import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';

import './About.css';

class About extends Component {
  componentDidMount() {
    document.body.style.backgroundColor = "#FFFFFF";
  }

  render() {
    return (
      <Grid className="About-body">
        <Row>
          <Col sm={8} smOffset={2}>
            <h2>Aloha, I'm Jeff!</h2>
            <p>I am a <a className="App-textlink" href="https://www.linkedin.com/in/jeffmori/">Startup Engineering Leader</a> at <a className="App-textlink" href="https://redcatsystems.com">RedCAT Systems</a> based out of Honolulu, Hawaii.</p>
            <p>I find balance between my passions on a daily basis — whether it be making things with technology, racing cars, cycling, travelling, or trying something new and exciting.</p>
            <p><b>Previously, I:</b></p>
            <ul className="About-list">
              <li><span>🚴 raced in the <a className="App-textlink" href="https://www.strava.com/activities/4231505265" target="_blank">Taiwan KOM Challenge</a>&nbsp;&nbsp;加油~！</span></li>
              <li><span>Learned Mandarin Chinese.</span></li>
              <li><span>Loved living in Taiwan on the <a className="App-textlink" href="https://goldcard.nat.gov.tw/en/" target="_blank">Employment Gold Card</a>.</span></li>
              <li><span>Started up my own software consultancy and went 100% remote from Hawaii.</span></li>
              <li><span>Built a Bitcoin debit card with <a className="App-textlink" href="https://www.shiftpayments.com/card" target="_blank">Shift Payments</a>, a Y Combinator financial technology startup in San Francisco.</span></li>
              <li><span><a className="App-textlink" href="https://youtu.be/lgLw_KheHKA?list=PLghZseJ2315k0ZQ2CeccgpsdlbUXt2Pej" target="_blank">Autocrossed </a> my 🚗.</span></li>
              <li><span>Drove across the United States <a className="App-textlink" href="https://youtu.be/cq7KzcwZwnc" target="_blank">frame by frame</a>.</span></li>
              <li><span>Battle-tested <a className="App-textlink" href="https://en.wikipedia.org/wiki/IBM_System_z" target="_blank">zero downtime processors</a>, at IBM in New York.</span></li>
              <li><span>Earned a 🎓 in Electrical and Computer Engineering at Carnegie Mellon University.</span></li>
              <li><span>Grew up in Tokyo and <a className="App-textlink" href="https://en.wikipedia.org/wiki/Waimea,_Hawaii_County,_Hawaii">Waimea</a>.</span></li>
            </ul>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/pages/About.js